import { useLocation } from "react-router-dom";
import { DashboardRoutes } from "@/router";

// Personal
export function isPersonalRegisterURL() {
  const currentURL = useLocation().pathname;
  return currentURL === DashboardRoutes.register.personal.url;
}
export function isMobilePersonalRegisterURL() {
  const currentURL = useLocation().pathname;
  return currentURL.includes(DashboardRoutes.register.mEditPersonal.root.url);
}

// TODO matchRoutes react-router

// Business
export function isBusinessRegisterURL() {
  const currentURL = useLocation().pathname;
  return currentURL.includes(DashboardRoutes.register.business.url);
}
export function isMobileBusinessRegisterURL() {
  const currentURL = useLocation().pathname;
  return currentURL.includes(DashboardRoutes.register.mEditBusiness.root.url);
}
